import { getDiagnosticReportFile } from "../api/api";

// Report files sit behind the dashboard's bearer-token auth, so a plain <a
// href> can't open them. Fetch the file, then show it from a blob URL. The
// tab is opened synchronously first — opening it after the await would be
// treated as a popup and blocked.
export const openReport = async (report) => {
  const tab = window.open("", "_blank");
  try {
    const blob = await getDiagnosticReportFile(report._id);
    const url = URL.createObjectURL(blob);
    if (tab) tab.location.href = url;
    else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (err) {
    tab?.close();
    throw err;
  }
};

export const formatFileSize = (bytes = 0) =>
  bytes >= 1024 * 1024 ? `${(bytes / (1024 * 1024)).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`;
